import React, { FC } from "react";
import TextField, { TextFieldProps } from "@material-ui/core/TextField";
import { styled } from "@material-ui/styles";

const StyledBaseInput = styled(TextField)<TextFieldProps>(({ multiline }) => ({
  "& .MuiInputBase-root": {
    height: multiline ? "auto" : 48,
    lineHeight: "25px",
  },
  "& label": {
    transform: "translate(14px, 17px) scale(1)",
  },
  "& label.Mui-focused": {
    color: "#034980",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "1px solid #9E9E9E",
      borderRadius: 4,
    },
    "&.Mui-focused fieldset": {
      border: "1px solid #034980",
    },
  },
}));

const BaseInput: FC<TextFieldProps> = (props) => {
  return <StyledBaseInput fullWidth {...props} />;
};

export default BaseInput;
